import angular from 'angular';
import controller from './wfCurrent.controller';
import template from './wfCurrent.html';
import WfCurrentComponent from './wfCurrent.component';
import affectListPreview from './builder/affectList-preview.json';
import WorkflowAffect from '~/scripts/services/model/workflow-affect';

const wfCurrentConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('wfCurrent', {
		title:                  'Workflow (current)',
		template,
		group:                  'advanced',
		children:               false,
		selectable:             true,
		settings:               new WfCurrentComponent(),
		icon:                   'fa fa-users',
		views:                  [
			{
				name:     'Display',
				template: 'kform/components/wfCurrent/display.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/common/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/wfCurrent/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		controller,
		/**
		 * @param {import('angular').auto.IInjectorService} $injector
		 * @param {any} $scope
		 */
		onEdit: /* @ngInject */ ($injector, $scope) => {
			$scope.affectList = affectListPreview.map(affect => new WorkflowAffect($injector, affect));
			$scope.showAddWorkflow = false;
			$scope.options = {
				checkBox:     false,
				history:      false,
				id:           'open',
				list:         'ALL',
				openWf:       false,
				showAdd:      $scope.showAddWorkflow && !$scope.readOnly,
				subscription: false,
			};
			$scope.formActionsOptions = {
				component: true,
				hideHistory: true,
			};
		},
	});
};

export default angular.module('app').config(wfCurrentConfig);
